(function () {
  var config = document.currentScript ? document.currentScript.dataset : {};

  if (!window.oaiq) {
    var queue = function () {
      queue.q.push(arguments);
    };
    queue.q = [];
    window.oaiq = queue;

    var sdk = document.createElement('script');
    sdk.async = true;
    sdk.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
    document.head.appendChild(sdk);
  }

  window.oaiq('consent', false);
  window.oaiq('init', {
    pixelId: '9pBxDcYvSq1FPZWf7C1VAa'
  });

  var consentGranted = false;
  var pageMeasured = false;
  var consentChecks = 0;

  function syncOpenAIConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var allowed = Boolean(
      privacy &&
      privacy.analyticsProcessingAllowed() &&
      privacy.marketingAllowed()
    );

    if (allowed !== consentGranted) {
      consentGranted = allowed;
      window.oaiq('consent', allowed);
    }

    if (allowed && !pageMeasured) {
      pageMeasured = true;
      window.oaiq('measure', 'page_viewed', {
        type: 'contents',
        contents: [
          {
            id: config.pageId || window.location.href,
            name: config.pageName || document.title,
            content_type: config.contentType || 'page'
          }
        ]
      });
    }
  }

  syncOpenAIConsent();
  var consentTimer = window.setInterval(function () {
    consentChecks += 1;
    syncOpenAIConsent();
    if (consentChecks >= 40 || pageMeasured) {
      window.clearInterval(consentTimer);
    }
  }, 250);

  document.addEventListener('visitorConsentCollected', syncOpenAIConsent);
})();
